type VariantAttribute = { name: string; value: string; key: string };

export const findVariantByAttributeValues = ({
  variants,
  attributeValues,
  returnPartialMatchingIfFullMatchIsNotFound = false,
}: {
  variants: {
    masterVariant?: boolean;
    sku: string;
    price: { centAmount: number };
    discount: { centAmount: number };
    isOutOfStock?: boolean;
    attributes: VariantAttribute[];
    image?: {
      imageUrl: string;
      label?: string;
      sku?: string;
    };
  }[];
  attributeValues: VariantAttribute[];
  returnPartialMatchingIfFullMatchIsNotFound?: boolean;
}) => {
  const foundVariant = variants?.find(({ attributes }) =>
    attributes.every((attr) => {
      const foundAttribute = attributeValues.find(
        (mainProductAttr) => mainProductAttr?.name === attr.name,
      );
      return !foundAttribute || foundAttribute.key === attr.key;
    }),
  );
  if (returnPartialMatchingIfFullMatchIsNotFound && !foundVariant) {
    const foundVariantPartialMatching = variants
      ?.filter(({ attributes }) =>
        attributes.some((attr) => {
          const foundAttribute = attributeValues.find(
            (mainProductAttr) => mainProductAttr?.name === attr.name,
          );
          return !foundAttribute || foundAttribute.key === attr.key;
        }),
      )
      ?.map((variant) => ({
        variant,
        matchingAttributesCount:
          variant.attributes.filter((attr) => {
            const foundAttribute = attributeValues.find(
              (mainProductAttr) => mainProductAttr?.name === attr.name,
            );
            return !foundAttribute || foundAttribute.key === attr.key;
          })?.length ?? 0,
      }))
      ?.sort((partialMatchingVariant1, partialMatchingVariant2) =>
        partialMatchingVariant1.matchingAttributesCount >
        partialMatchingVariant2.matchingAttributesCount
          ? -1
          : 1,
      )?.[0]?.variant;
    return foundVariantPartialMatching;
  }
  return foundVariant;
};

export const getProductUrlFromProductVariant = (variant: {
  id: string;
  sku: string;
  images: { url: string }[];
  price: {
    totalPrice: { centAmount: number; currencyCode: string };
    discounts: { displayName: string; value: { centAmount: number } }[];
  }[];
  attributes: { name: string; value: string }[];
}): string =>
  variant?.attributes?.find((attr) => attr.name === 'productUrl')?.value ?? '';
